import { ApolloProvider } from "@apollo/client"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles"
import { ConnectedRouter } from "connected-react-router"
import ReactDOM from "react-dom"
import { AuthProvider } from "react-oidc-context"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/es/integration/react"
import apolloClient from "./apolloClient"
import App from "./containers/App"
import InitializeApp from "./containers/InitializeApp"
import { history } from "./history"
import { oidcConfig } from "./oidcConfig"
import { getPersistor } from "./persist"
import { signinCallback } from "./sagas/user/authentication"
import { store } from "./store"
import theme from "./theme"
import { DateSettingsProvider } from "./containers/InitializeApp/DateSettingsProvider"

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={getPersistor()}>
      <ApolloProvider client={apolloClient}>
        <ConnectedRouter history={history}>
          <AuthProvider {...oidcConfig} onSigninCallback={authUser => signinCallback(authUser, store.dispatch)}>
            <DateSettingsProvider>
              <InitializeApp>
                <StyledEngineProvider injectFirst>
                  <MuiThemeProvider theme={theme}>
                    <CssBaseline />
                    <App />
                  </MuiThemeProvider>
                </StyledEngineProvider>
              </InitializeApp>
            </DateSettingsProvider>
          </AuthProvider>
        </ConnectedRouter>
      </ApolloProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
)
